import { useEffect, useState } from "react";
import RIcon from "../../../components/RIcon";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 320) {
        setLeaving(false);
        setVisible(true);
      } else {
        if (visible) {
          setLeaving(true);
          setTimeout(() => { setVisible(false); setLeaving(false); }, 300);
        }
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [visible]);

  if (!visible) return null;

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      title="回到顶部"
      className="fixed bottom-8 right-8 z-50 group cursor-pointer"
      style={{
        opacity: leaving ? 0 : 1,
        transform: leaving ? "translateY(12px) scale(0.9)" : "translateY(0) scale(1)",
        transition: "opacity 0.3s ease, transform 0.3s ease",
      }}
    >
      {/* Outer ring pulse */}
      <span className="absolute inset-0 rounded-full bg-[#0EA5A0]/20 animate-ping pointer-events-none" />

      {/* Button body */}
      <span className="relative flex flex-col items-center justify-center w-12 h-12 rounded-full bg-[#0EA5A0] group-hover:bg-[#0D9590] transition-colors shadow-lg shadow-[#0EA5A0]/30">
        <RIcon name="arrow-up-line" className="text-white text-lg transition-transform group-hover:-translate-y-0.5" />
      </span>
    </button>
  );
}
